/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base component.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import { OverviewMovableComponents, renderContentInAuthorMode } from '../../modules';
import { useAccountRefreshNonPersistentStore } from '../../modules/store/overviewStore';

const EarningsSummary = dynamic(() => import('./EarningsSummary').then(mod => mod.EarningsSummary));

export const EarningsSummaryConfig = {
  emptyLabel: 'Earnings Summary',
  isEmpty: () => true,
  resourceType: ``,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EarningsSummaryEditable = (props: any) => {
  const { setAccountRefreshComponentLoading } = useAccountRefreshNonPersistentStore(state => state);

  const isHidden = props?.model?.hideEarningsSummary;

  useEffect(() => {
    if (isHidden) {
      setAccountRefreshComponentLoading({ [OverviewMovableComponents.EARNINGS_SUMMARY]: false });
    }
  }, [isHidden]);

  return (
    <EditableComponent config={EarningsSummaryConfig} {...props}>
      <>
        {(!isHidden || props?.isAuthorMode) && <EarningsSummary {...props} />}
        {props?.isAuthorMode &&
          renderContentInAuthorMode({
            totalNumberOfCards: props?.totalNumberOfCards ?? [],
            pagePath: props?.pagePath,
            itemPath: props?.itemPath,
          })}
      </>
    </EditableComponent>
  );
};
